import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'lgb-rate',
  standalone: false,
  templateUrl: './rate.html',
  styleUrl: './rate.css',
})
export class Rate {
  readonly _rate=input.required<number>({alias: 'rate'});
  readonly size=input('xs');
  readonly rate=computed(() => Math.round(this._rate()));

  getClass(){
    return {
      'rating-xs': this.size()=='xs',
      'rating-sm': this.size()=='sm',
      'rating-md': this.size()=='md',
      'rating-lg': this.size()=='lg',
      'rating-xl': this.size()=='xl'
    }
  }
}
